// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  department_code: yup.string().label("Departement code").required(),
  department_name: yup.string().label("Departement name").required()
})